// extracted by mini-css-extract-plugin
export default {"card":"CardCatalog_card__jh1cS","cardContainer":"CardCatalog_cardContainer__OwLqe","card_img":"CardCatalog_card_img__rsTec","card_info":"CardCatalog_card_info__a5I0k"};